import { useColorModeValue, useToken } from '@chakra-ui/react';

// O recharts pinta com cor CSS, não com token do Chakra: resolvemos os
// tokens aqui para os gráficos usarem as mesmas cores dos Badges e ícones.
// Verde é concluído, laranja é o que falta e vermelho é problema, em todo o
// Dashboard.
export function useCoresDashboard() {
  const [verde, laranja, vermelho, azul, azulClaro, grade, gradeEscura, eixo] =
    useToken('colors', [
      'green.500',
      'orange.400',
      'red.500',
      'blue.500',
      'blue.300',
      'gray.200',
      'gray.700',
      'gray.500',
    ]);
  // Uma cor por forma de movimentação (até seis mais "Outros"), para a pizza
  // e as barras de Movimentações distinguirem as categorias. Sem verde nem
  // vermelho: no Dashboard eles querem dizer concluído e problema.
  const categorias = useToken('colors', [
    'blue.500',
    'teal.400',
    'purple.500',
    'orange.400',
    'cyan.600',
    'pink.400',
    'gray.400',
  ]);

  return {
    conciliado: verde,
    pendente: laranja,
    divergente: vermelho,
    entrada: verde,
    saida: vermelho,
    saldo: useColorModeValue(azul, azulClaro),
    grade: useColorModeValue(grade, gradeEscura),
    eixo,
    categorias,
  };
}
